import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const OPTION_SIDE = {
  '0': 'LEFT',
  '1': 'RIGHT',
  'DEFAULT': 'unknownSide',
};

export function HexPathSelectRow(props) {
  const onNodeClick = (componentID) => {
    props.updateSelection({
      nodeId: props.nodeId,
      componentID,
    });
  };
  const getSelectedComponent = () => {
    let selected = props.nodeOptions.find((option) => option.selected);
    return selected ? selected.id : null;
  };

  const [selectedId, setselectedId] = React.useState(getSelectedComponent());

  React.useEffect(() => {
    setselectedId(getSelectedComponent());
  }, [props.nodeOptions]);

  const setIsCorrect = (component) => props.nodeComponent === component.id;

  const getWrapperClass = () => {
    return props.nodeComponent === selectedId
      ? 'hexPathRow-complete'
      : `hexPathRow`;
  };

  const getOptionWrapper = (option, isCorrect) => {
    return option.selected && isCorrect ? 'optionItem__correct' : 'optionItem';
  };

  const getSideClassName = (key) => {
    if (OPTION_SIDE.hasOwnProperty(key)) {
      return `optionItem__${OPTION_SIDE[key].toLowerCase()}`;
    } else {
      return `optionItem__${OPTION_SIDE.DEFAULT.toLowerCase()}`;
    }
  };

  const renderOption = (option, key) => {
    const feedbackMessage = props.nodeFeedback[option.id] ?? '';
    const isCorrect = setIsCorrect(option);
    const optionWrapper = getOptionWrapper(option, isCorrect);
    const sideClass = getSideClassName(key);
    return (
      <div className={`${optionWrapper} ${sideClass}`} key={option.id}>
        {React.cloneElement(props.pathNode, {
          component: option,
          isCorrect,
          onNodeClick: onNodeClick,
          feedbackMessage,
        })}
      </div>
    );
  };

  const wrapperClass = getWrapperClass();
  return (
    <div className='hexPathRowWrap'>
      <div className={wrapperClass}>
        <h5 className={`${wrapperClass}_description`}>
          {props.nodeDescription}
        </h5>
        <div className={`${wrapperClass}_options`}>
          {props.nodeOptions.map(renderOption)}
        </div>
      </div>
    </div>
  );
}

HexPathSelectRow.propTypes = {
  /**
   * Function to invoke when an option is selected
   */
  updateSelection: PropTypes.func,
  /**
   * Unique Id for the node
   */
  nodeId: PropTypes.number,
  /**
   * List of options avaliable
   */
  nodeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unique Id for option
       */
      id: PropTypes.number,
      /**
       * Title of the  node
       */
      title: PropTypes.string,
      /**
       * Url to icon image of the Hexaogn Card
       */
      image: PropTypes.string,
      /**
       * Modal for detailed description of card
       */
      modal: PropTypes.object,
      /**
       * Boolean specifying if card is selected
       */
      selected: PropTypes.bool,
    })
  ),
  /**
   * Unique Id for the answer option
   */
  nodeComponent: PropTypes.number,
  /**
   * Object with feedback messages for all incorrect options
   */
  nodeFeedback: PropTypes.object,
  /**
   * React Component to be used as option
   */
  pathNode: PropTypes.element.isRequired,
  /**
   * Text to be displayed on the Component
   */
  nodeDescription: PropTypes.string,
};

HexPathSelectRow.defaultProps = {
  nodeOptions: [],
  nodeDescription: '',
};
